export type TranslationScope = "grid" | "menu" | "eform" | "service" | "general";

export interface TranslationEntry {
  module: string;
  field: string;
  scope?: TranslationScope;
  lang: string;
  label: string;
}

export interface TranslationLookupArgs {
  module: string;
  field: string;
  lang: string;
  scope?: TranslationScope;
  fallback?: string;
}

export default class TranslationResolver {
  private entries: TranslationEntry[];

  constructor(entries: TranslationEntry[] = []) {
    this.entries = entries;
  }

  public setEntries(entries: TranslationEntry[]) {
    this.entries = entries || [];
  }

  public addEntries(entries: TranslationEntry[]) {
    this.entries = [...this.entries, ...(entries || [])];
  }

  private normalize(value: any): string {
    return String(value || "").trim().toLowerCase();
  }

  public translate(args: TranslationLookupArgs): string {
    const { module, field, lang, scope, fallback } = args;
    const moduleKey = this.normalize(module);
    const fieldKey = String(field || "").trim();
    const langKey = this.normalize(lang);

    const exact = this.entries.find(
      (e) =>
        this.normalize(e.module) === moduleKey &&
        String(e.field || "").trim() === fieldKey &&
        this.normalize(e.lang) === langKey &&
        (scope ? e.scope === scope : true)
    );

    if (exact?.label) return exact.label;

    const scopeAgnostic = this.entries.find(
      (e) =>
        this.normalize(e.module) === moduleKey &&
        String(e.field || "").trim() === fieldKey &&
        this.normalize(e.lang) === langKey
    );

    if (scopeAgnostic?.label) return scopeAgnostic.label;

    return fallback || field;
  }
}
